import React from 'react'
import classnames from 'classnames'
import { IsViewport } from '@zambezi/layout-grid'

import { followStoreLink$ } from '../navigation'
import { getAvatarState } from '@apiEnabler/ob-common/lib/tpps'

import Avatar from './Avatar'

import style from './VrpTppCard.module.scss'

export default function VrpTppCard({ tpp, index, consentType }) {
  const message = messageForTpp(tpp)
  return (
    <button
      className={`${style.activeCard} js-vrp-tpp-card-${index} legacyCard`}
      onClick={() =>
        followStoreLink$.next(
          `/recurring-payments/${consentType}/tpps/${tpp.get(
            'clientId'
          )}/payments`
        )
      }
    >
      <div className={style.content}>
        <IsViewport isTablet isDesktop isWidescreen>
          <Avatar
            content={tpp.get('agentName') || tpp.get('clientName')}
            className={style.avatar}
            state={getAvatarState(tpp)}
          />
        </IsViewport>
        <span className={style.subContent}>
          <span className={classnames(style.clientName, 'js-tpp-name')}>
            {tpp.get('clientDisplayName')}
          </span>
          {message}
        </span>
      </div>
    </button>
  )
}

export function EmptyVrpTppCard({ label }) {
  return (
    <div className={classnames('js-vrp-tpp-card-empty', style.card)}>
      <div className={style.content}>
        <IsViewport isTablet isDesktop isWidescreen>
          <Avatar className={style.hiddenAvatar} />
        </IsViewport>
        <span className={`${style.emptyMessage} js-message`}>
          {label === 'Connected'
            ? `You've no connections`
            : `You've no history of disconnections`}
        </span>
      </div>
    </div>
  )
}

function messageForTpp(tpp) {
  const clientDisplayName = tpp.get('clientDisplayName')
  if (
    tpp.get('flag') === 'TPP_SUSPENDED' ||
    tpp.get('flag') === 'TPP_CLIENT_SUSPENDED'
  ) {
    return (
      <span className={`${style.message} js-tpp-msg`}>
        {clientDisplayName} has been suspended. Please contact{' '}
        {clientDisplayName} for further information.
      </span>
    )
  }

  if (tpp.get('flag') === 'TPP_REVOKED') {
    return (
      <span className={`${style.message} js-tpp-msg`}>
        {clientDisplayName} has been revoked. Please contact {clientDisplayName}{' '}
        for further information.
      </span>
    )
  }
}
